(function () {
  /* ElpaFix - Hizli Al duzeltmesi + notify=1 oto-acilma engeli */

  /* ---- 0) Urun sayfasi acilisinda secili rengin gorseli (2026-09-23) ----
     ?variant=ID ile gelinen varyantin kendi gorseli yoksa ana gorsel kapakta
     (ornegin turuncu) kaliyordu. Aktif renk swatch'inin gorseline gecir. */
  function efColorImgInit() {
    try {
      var img = document.getElementById('efp-current-img');
      if (!img) return;
      var sw = document.querySelector('.efp__opt--swatch.is-active[data-img]');
      if (sw) img.src = sw.getAttribute('data-img');
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', efColorImgInit);
  } else {
    efColorImgInit();
  }

  /* ---- 1) notify=1 otomatik popup engeli ---- */
  try {
    var sp = new URLSearchParams(window.location.search);
    if (sp.get('notify') === '1') {
      sp.delete('notify');
      var qs = sp.toString();
      var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState(null, '', newUrl);
    }
  } catch (e) {}

  var notifyUserOpened = false;
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.js-ef-notify')) {
      notifyUserOpened = true;
    }
  }, true);

  function guardNotify() {
    var ov = document.getElementById('efNotifyOverlay');
    if (!ov || !window.MutationObserver) return;
    var killUntil = Date.now() + 2500;
    var mo = new MutationObserver(function () {
      if (ov.classList.contains('is-open') && !notifyUserOpened && Date.now() < killUntil) {
        ov.classList.remove('is-open');
        ov.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
    mo.observe(ov, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardNotify);
  } else {
    guardNotify();
  }

  /* ---- 2) Hizli Al ---- */
  var hzBusy = false;
  function digits(v) { return (v == null ? '' : String(v)).replace(/[^0-9]/g, ''); }
  function isNum(s) { return s.length > 0 && digits(s) === s; }

  function getVidFromDom() {
    var f = document.querySelector('form[action*=cart]');
    if (f) {
      var idEl = f.querySelector('[name=id]');
      if (idEl && idEl.value && digits(idEl.value)) return digits(idEl.value);
    }
    var checked = document.querySelector('sht-variant-radios input[type=radio]:checked, .product__info-wrapper input[type=radio]:checked');
    if (checked && digits(checked.value) && isNum((checked.value || '').trim())) return digits(checked.value);
    return null;
  }

  function selectedOptionValues() {
    var vals = [];
    document.querySelectorAll('sht-variant-radios input[type=radio]:checked, .product__info-wrapper input[type=radio]:checked').forEach(function (r) {
      var t = (r.value || '').trim().toLowerCase();
      if (t && !isNum(t)) vals.push(t);
    });
    document.querySelectorAll('.product__info-wrapper [aria-checked=true], .product__info-wrapper .is-selected[data-value], .product__info-wrapper .active[data-value]').forEach(function (b) {
      var t = (b.getAttribute('data-value') || b.textContent || '').trim().toLowerCase();
      if (t) vals.push(t);
    });
    return vals;
  }

  function resolveVid() {
    var d = getVidFromDom();
    if (d) return Promise.resolve(d);
    var handle = '';
    var m = window.location.pathname.split('/products/')[1];
    if (m) handle = m.split('?')[0].split('/')[0];
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var vs = prod.variants || [];
        if (!vs.length) return null;
        if (vs.length === 1) return String(vs[0].id);
        var sel = selectedOptionValues();
        var match = vs.find(function (v) {
          var opts = (v.options || []).map(function (o) { return (o || '').toString().trim().toLowerCase(); });
          return sel.length && sel.every(function (s) { return opts.indexOf(s) !== -1; });
        });
        if (match) return String(match.id);
        var avail = vs.find(function (v) { return v.available; });
        return String((avail || vs[0]).id);
      })
      .catch(function () { return null; });
  }

  function doHizliAl(btn) {
    if (hzBusy) return;
    hzBusy = true;
    btn.style.opacity = '.7';
    btn.style.pointerEvents = 'none';
    resolveVid().then(function (vid) {
      if (!vid) {
        hzBusy = false; btn.style.opacity = ''; btn.style.pointerEvents = '';
        alert('Lutfen bir secenek secin.');
        return;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = '/checkout';
      });
    }).catch(function () {
      hzBusy = false; btn.style.opacity = ''; btn.style.pointerEvents = '';
      alert('Bir hata olustu, lutfen tekrar deneyin.');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.js-ef-hizli-al') : null;
    if (!btn) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    doHizliAl(btn);
  }, true);
})();
